/* ALCOBA - ajustes de la ficha de producto.
   1) Sincroniza el boton flotante con el principal: si uno dice Agotado,
      el otro tambien.
   2) Mide la cabecera y publica su altura como --alcoba-header-h, para
      que en escritorio la barra se cuelgue justo debajo y no compita
      con el banner de cookies ni con la barra inferior del navegador.
   3) La lupa de la imagen amplia por donde se ha pinchado, no desde el
      centro. Antes cortaba por un punto arbitrario del producto. */
(function () {
  'use strict';

  /* --- 1. Altura de la cabecera --- */
  var header = document.getElementById('shopify-section-header');
  function setHeaderHeight() {
    if (!header) return;
    var h = Math.round(header.getBoundingClientRect().height);
    if (h > 0) document.documentElement.style.setProperty('--alcoba-header-h', h + 'px');
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight, { passive: true });
  window.addEventListener('load', setHeaderHeight);

  /* --- 2. Lupa centrada en el punto pinchado --- */
  var mainImg = document.getElementById('MainProductImage');
  if (mainImg) {
    mainImg.addEventListener('click', function (e) {
      var r = mainImg.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      mainImg.style.transformOrigin = x.toFixed(1) + '% ' + y.toFixed(1) + '%';
    });
    /* Al cambiar de foto, se vuelve al encuadre normal. */
    Array.prototype.forEach.call(document.querySelectorAll('.product__thumb'), function (t) {
      t.addEventListener('click', function () {
        mainImg.classList.remove('is-zoomed');
        mainImg.style.transformOrigin = '';
      });
    });
  }

  /* --- 3. Sincronizacion de botones --- */
  var main = document.getElementById('AddToCart');
  var sticky = document.getElementById('StickyAtc');
  if (!main || !sticky) return;

  function sync() {
    sticky.disabled = main.disabled;
    if (sticky.textContent.trim() !== main.textContent.trim()) {
      sticky.textContent = main.textContent;
    }
  }

  sync();

  var mo = new MutationObserver(sync);
  mo.observe(main, {
    attributes: true,
    attributeFilter: ['disabled'],
    childList: true,
    characterData: true,
    subtree: true
  });
})();
